import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import authClient from '../../../api/auth';

const useSendPasswordResetMutation = (
  options?: UseMutationOptions<void, Error, string>,
) => {
  return useMutation({
    mutationFn: (email: string) => authClient.sendPasswordResetEmail(email),
    ...options,
  });
};

export default useSendPasswordResetMutation;
